'use client';

/**
 * Check is mobile when innerWidth is smaller or equal 768
 * @returns boolean isMobile or not
 */
function isMobile() {
    if (typeof window !== 'undefined') {
        return window.innerWidth <= 768;
    }
    return false;
}

export { isMobile };
//# sourceMappingURL=helper.js.map
